import isBrowser from 'utils/isBrowser'

const PROTOCOL = (isBrowser ? window.location.protocol : "") + "//"
export default PROTOCOL
